export const getAuthHost = () => {
	if (process.env.REACT_APP_AUTH_API_HOST) {
		return process.env.REACT_APP_AUTH_API_HOST;
	}

	return process.env.REACT_APP_STAGING
		? 'https://auth-api.wiselysoftware.com'
		: 'https://prod-auth-api.wiselysoftware.com';
};



// WEBPACK FOOTER //
// ./src/utils/getAuthHost.js